import SSLGenerationFormsReducer from './SSLGenerationFormsReducer';
import { combineReducers } from 'redux';

const reducers = combineReducers({
    'SSLGenerationForms': SSLGenerationFormsReducer
});

export default reducers;
